// extracted by mini-css-extract-plugin
export default {"title":"Terms_title__iuoYJ","light":"Terms_light__edXT8","dark":"Terms_dark__EGO4N","content":"Terms_content__qrtpD"};